import client from '../../client'
import {
  MeResponse,
  CreateReservationResponse,
  DestroyReservationResponse,
  ReservationId,
  MeParams,
  PastReservation,
  ListPastReservationsParams,
} from './types'
import { ApiResponse, PagerMeta } from '../../types'
import { TimetableId } from '../timetables'

export * from './types'

export const me = async (
  params?: MeParams
): Promise<ApiResponse<MeResponse, PagerMeta>> =>
  await client.get('/user/reservations/me', { params })

export const create = async (timetableId: TimetableId) => {
  const { data }: ApiResponse<CreateReservationResponse> = await client.post(
    '/user/reservations',
    {
      timetableId,
    }
  )
  return data
}

export const destroy = async (id: ReservationId) => {
  const { data }: ApiResponse<DestroyReservationResponse> = await client.delete(
    `/user/reservations/${id}`
  )
  return data
}

export const listPastReservations = async (
  params?: ListPastReservationsParams
) => {
  const { data, meta }: ApiResponse<PastReservation[], PagerMeta> =
    await client.get('/user/reservations/me/past', { params })

  return { data, meta }
}
